/**
 * Curso ativo da sessão, para quem não é componente React.
 *
 * O curso deixou de ser estado do servidor: o token identifica a pessoa e cada
 * requisição declara em qual curso ela está, no header `X-Course-Id`. Quem
 * monta as requisições é o `authenticatedFetch`, uma função de módulo que não
 * enxerga contexto React — daí este registro mínimo, escrito pela casca do curso
 * e lido pela camada de rede.
 *
 * É deliberadamente burro: quem manda é a URL, e o `CourseApp` publica aqui o
 * curso do manifesto que acabou de montar. Ler daqui nunca decide acesso — o
 * servidor confere a matrícula a cada requisição.
 */

let activeCourseId: number | null = null;

export function setActiveCourse(topicId: number | null): void {
  activeCourseId = topicId;
}

export function getActiveCourse(): number | null {
  return activeCourseId;
}

/**
 * Header do curso, ou nada quando ainda não há curso aberto (vitrine, login).
 *
 * Sem curso o backend cai na matrícula única da conta, que é o comportamento de
 * quem só tem um curso — a esmagadora maioria.
 */
export function courseHeader(): Record<string, string> {
  return activeCourseId == null ? {} : { 'X-Course-Id': String(activeCourseId) };
}
